module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img49.a26a75ab.jpg";